import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listPlans, type Plan } from '../api/plans';

export function PlansPage() {
  const [plans, setPlans] = useState<Plan[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    listPlans()
      .then(setPlans)
      .catch((e) => setError(e.message ?? 'Errore caricamento'));
  }, []);

  return (
    <div className="page">
      <div className="page-head">
        <h1>Pianificazioni</h1>
        <Link to="/plans/new" className="btn btn-primary">
          + Nuova pianificazione
        </Link>
      </div>

      <p className="muted">
        Bozze di itinerari. Pianifica le tue tappe sulla mappa, riordinale a piacere, poi
        convertile in un viaggio quando sei pronto a partire.
      </p>

      {error && <p className="err">{error}</p>}
      {!error && plans === null && <p className="muted">Caricamento…</p>}

      {plans && plans.length === 0 && (
        <div className="empty-state">
          <p>Nessuna pianificazione ancora. Iniziane una.</p>
        </div>
      )}

      {plans && plans.length > 0 && (
        <ul className="plan-list">
          {plans.map((p) => (
            <li key={p.id}>
              <Link to={`/plans/${p.id}`} className="plan-card">
                <h2 className="cd-title-upper">{p.title}</h2>
                {p.description && <p className="desc">{p.description}</p>}
                <p className="counts">
                  <span>{p.stagesCount} tappe</span>
                  <span>·</span>
                  <span className="muted">aggiornata {formatRel(p.updatedAt)}</span>
                </p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function formatRel(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString('it-IT', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
